import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/index.css";

import "dayjs/locale/zh-cn";
import locale from "element-plus/es/locale/lang/zh-cn";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import axios from "axios";
import "default-passive-events";
import * as echarts from "echarts";
import { ElMessage } from "element-plus";
import './utils/browserPatch';



// 创建 Vue 3 应用实例
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
// echarts全局
app.config.globalProperties.$echarts = echarts;

// 使用 Vue Router 和 Vuex
app.use(router);
app.use(store);
app.use(ElementPlus, { locale });

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        if (response.data.code == " 60003") {
            ElMessage.error(response.data.data);
            router.replace("/login"); //页面跳转至登录页面
            return;
        }
        return response;
    },
    (error) => {

        return Promise.reject(error);
    }
);

// 配置 warnHandler 以忽略特定警告
// app.config.errorHandler = function (err, warn, info) {
// };

// 挂载应用
app.mount("#app");